export enum UserType {
    CITIZEN = '1',
    COMPANY = '2',
}

export enum RequestTypeId {
    PDS_FIVE = '1',
    PDS_THIRTY_TWO = '2',
    PDS_TEN = '3',
}

export enum OwnerType {
    SINGLE = '1',
    MULTIPLE = '2',
}

export enum RequestActionType {
    CAN_EDIT = 1,
    CAN_VIEW = 2,
    CAN_DELETE = 3,
    CAN_CANCEL = 4,
}

export enum WarningExcel {
    WARN_DATE = '1', //'กรอกระบุวันที่ตามรูปแบบที่กำหนด dd/mm/yyyy กรุณาลองใหม่อีกครั้ง'
    WARN_DATA = '2', //'กรอกข้อมูลไม่ครบถ้วน กรุณาลองใหม่อีกครั้ง'
    WARN_COLUMN = '3', //'ตำแหน่ง Column ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง'
    WARN_DATA_LENGTH = '4', //'ข้อมูลไม่ครบตามจำนวนที่กำหนดไว้ กรุณาลองใหม่อีกครั้ง'
    WARN_TEMPLATE = '5', //'ไฟล์ที่อัปโหลดไม่ตรงตามเทมเพลต กรุณาลองใหม่อีกครั้ง'
}

export enum UploadFile {
    WARN_SIZE = '1',
    WARN_DUP = '2',
    WARN_LENGTH = '3',
    WARN_TYPE = '4',
}

export enum MenuId {
    REQUEST_MANAGE = '1',
    VERIFY = '2',
    ESTATE = '3',
    PAYMENT_HISTORY = '4',
    FAQ = '5',
    NEWS_MANAGE = '6',
    FAQ_MANAGE = '7',
    DOCUMENT = '8',
    MESSAGE = '9',
    PROFILE = '10',
}